/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeExportTypeFilters.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Export Type Filter Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Tuesday, December 10, 2019 - 09:25:27 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      12/10/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const EXPORTTYPEFILTER_LIST_CONTAINER_LOADED = 'EXPORTTYPEFILTER_LIST_CONTAINER_LOADED';
export const EXPORTTYPEFILTER_LIST_CONTAINER_UNLOADED = 'EXPORTTYPEFILTER_LIST_CONTAINER_UNLOADED';
export const EXPORTTYPEFILTER_LIST_TABLE_LOADED = 'EXPORTTYPEFILTER_LIST_TABLE_LOADED';
export const EXPORTTYPEFILTER_LIST_TABLE_UNLOADED = 'EXPORTTYPEFILTER_LIST_TABLE_UNLOADED';

export const EXPORTTYPEFILTER_LIST_CHANGE_GROUP = 'EXPORTTYPEFILTER_LIST_CHANGE_GROUP';
export const EXPORTTYPEFILTER_SELECT_ROW = 'EXPORTTYPEFILTER_SELECT_ROW';
export const EXPORTTYPEFILTER_UPDATE_VALUE = 'EXPORTTYPEFILTER_UPDATE_VALUE';
export const EXPORTTYPEFILTER_SET_DATATYPE_SELECT = 'EXPORTTYPEFILTER_SET_DATATYPE_SELECT';

export const EXPORTTYPEFILTER_ADD = 'EXPORTTYPEFILTER_ADD';
export const EXPORTTYPEFILTER_EDIT = 'EXPORTTYPEFILTER_EDIT';
export const EXPORTTYPEFILTER_DELETE = 'EXPORTTYPEFILTER_DELETE';
export const EXPORTTYPEFILTER_OPEN_WARNING = 'EXPORTTYPEFILTER_OPEN_WARNING';
export const EXPORTTYPEFILTER_CLOSE_WARNING = 'EXPORTTYPEFILTER_CLOSE_WARNING';
export const EXPORTTYPEFILTER_DELETE_DISABLE = 'EXPORTTYPEFILTER_DELETE_DISABLE';
export const EXPORTTYPEFILTER_VIEW_CHILD_ITEMS = 'EXPORTTYPEFILTER_VIEW_CHILD_ITEMS';

export const EXPORTTYPEFILTER_EDIT_CONTAINER_LOADED = 'EXPORTTYPEFILTER_EDIT_CONTAINER_LOADED';
export const EXPORTTYPEFILTER_EDIT_CONTAINER_UNLOADED = 'EXPORTTYPEFILTER_EDIT_CONTAINER_UNLOADED';
export const EXPORTTYPEFILTER_EDIT_FORM_LOADED = 'EXPORTTYPEFILTER_EDIT_FORM_LOADED';
export const EXPORTTYPEFILTER_EDIT_FORM_UNLOADED = 'EXPORTTYPEFILTER_EDIT_FORM_UNLOADED';

export const EXPORTTYPEFILTER_SET_GROUP_SELECT = 'EXPORTTYPEFILTER_SET_GROUP_SELECT';
export const EXPORTTYPEFILTER_EDIT_DATA_LOAD = 'EXPORTTYPEFILTER_EDIT_DATA_LOAD';

export const EXPORTTYPEFILTER_EDIT_CONTAINER_SUBMIT = 'EXPORTTYPEFILTER_EDIT_CONTAINER_SUBMIT';
export const EXPORTTYPEFILTER_EDIT_CONTAINER_CANCEL = 'EXPORTTYPEFILTER_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeExportTypeFilters.js